import React from "react";
import { withTranslation } from "react-i18next";
import Img404 from "../image/404.png";

const NotFound = (props) => {
  const { t } = props;
  return (
    <div>
      <img className="notFound-img" src={Img404} alt="Logo"></img>
      <h3>404</h3>
      <span className="notFound-msg">{t("not_found")}</span>
    </div>
  );
};

export default withTranslation()(NotFound);
